<template>
    <div class="w-full py-4 column_start_start">
        <div class="row_center_start w-full flex-wrap mb-3">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">{{ timeLabel }}</text>
            <text class="font-base mr-2">{{ deliveryDate }}</text><text class="font-base">{{ deliveryTimeText }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap mb-3">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">地址</text>
            <text class="font-base">{{ deliveryAddress }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap mb-3">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">聯絡人</text>
            <text class="font-base">{{ recipientName }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap" :class="{ 'mb-3': invoiceVatNumber || invoiceCarrier || invoiceNpoBan }">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">電話</text>
            <text class="font-base">{{ deliveryPhone }}</text>
        </div>
        <!-- 統一編號：有資料時才顯示 -->
        <div class="row_center_start w-full flex-wrap mb-3" v-if="invoiceVatNumber">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">統一編號</text>
            <text class="font-base">{{ invoiceVatNumber }}</text>
        </div>
        <!-- 手機載具：有資料時才顯示 -->
        <div class="row_center_start w-full flex-wrap mb-3" v-if="invoiceCarrier">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">手機載具</text>
            <text class="font-base">{{ invoiceCarrier }}</text>
        </div>
        <!-- 愛心碼：有資料時才顯示 -->
        <div class="row_center_start w-full flex-wrap" v-if="invoiceNpoBan">
            <text class="font-base font-semibold text-[#AAA] w-[80px] flex-shrink-0">愛心碼</text>
            <text class="font-base">{{ invoiceNpoBan }}</text>
        </div>
        <div v-if="isRetailDelivery && isCashPayment && customPaymentText"
            class="delivery-custom-payment-description">
            <div class="custom-payment-inner">
                <div>店家支付說明：</div>
                <div v-html="customPaymentText"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        timeLabel() {
            return this.isRetailDelivery ? '送達時段' : '送達時間'
        },
        isRetailDelivery() {
            return this.geturlParameters.method === 'retailDelivery'
        },
        isCashPayment() {
            return this.getPayment.paymentType === 'cash'
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryPeriod() {
            return this.getPayment.deliveryPeriod
        },
        deliveryTimeText() {
            return this.isRetailDelivery ? this.deliveryPeriod : this.deliveryTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        recipientName() {
            return this.getPayment.recipientName || ''
        },
        deliveryPhone() {
            return this.getPayment.phone
        },
        // 取得當前選擇的發票類型索引
        // 0: 紙本發票, 1: 手機載具, 2: 統一編號, 3: 愛心碼
        invoiceTypeIndex() {
            return this.getPayment.invoiceTypeIndex ?? 0
        },
        // 手機載具（只在 invoiceTypeIndex === 1 時顯示）
        invoiceCarrier() {
            if (this.invoiceTypeIndex === 1) {
                return this.getPayment.invoiceCarrier || ''
            }
            return ''
        },
        // 統一編號（只在 invoiceTypeIndex === 2 時顯示）
        invoiceVatNumber() {
            if (this.invoiceTypeIndex === 2) {
                return this.getPayment.invoiceVatNumber || ''
            }
            return ''
        },
        // 愛心碼（只在 invoiceTypeIndex === 3 時顯示）
        invoiceNpoBan() {
            if (this.invoiceTypeIndex === 3) {
                return this.getPayment.invoiceNpoBan || ''
            }
            return ''
        },
        customPaymentText() {
            return this.$store.getters['basic/customPaymentText']
        },
    }
}
</script>
<style lang="scss">
.delivery-custom-payment-description {
    width: 100%;
    margin-top: 12px;
    padding: 10px 14px;
    font-size: 14px;
    color: #FD5001;
    line-height: 1.5;
    border: 1px solid #FD5001;
    border-radius: 6px;
    display: flex;
    justify-content: center;
}

.custom-payment-inner {
    text-align: left;
}
</style>
